"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _colors = require("../../../../mixins/colors");

//
//
//
//
//

var Chart = require("chart.js");
exports.default = {
  props: ["data", "height", "max"],

  mounted: function mounted() {
    this.render();
  },


  methods: {
    render: function render() {
      var myChart = new Chart(this.$refs.canvas, {
        type: "horizontalBar",
        data: {
          labels: [""],
          datasets: [{
            label: "",
            backgroundColor: _colors.CHART_MAIN_COLOR,
            data: [this.data.average]
          }]
        },
        options: {
          animation: false,
          legend: {
            display: false
          },
          scales: {
            xAxes: [{
              ticks: {
                suggestedMax: this.max,
                beginAtZero: true // minimum value will be 0.
              }
            }],
            maintainAspectRatio: true
          }
        }
      });
    }
  }
};


//////////////////
// WEBPACK FOOTER
// ./~/babel-loader/lib?cacheDirectory!./~/vue-loader/lib/selector.js?type=script&index=0!./resources/assets/js/components/reports/charts/elements/HorizontalBar.vue
// module id = S58u
// module chunks = 0 1